import * as React from "react";
import { cn } from "../../lib/utils";
import { TRUST_BADGES_STYLES } from "./constants";
import type { TrustBadgesProps } from "./types";

export const TrustBadges = React.forwardRef<HTMLElement, TrustBadgesProps>(
  ({ className, title, badges, ...props }, ref) => {
    return (
      <section
        ref={ref}
        className={cn(TRUST_BADGES_STYLES.root, className)}
        {...props}
      >
        {title && <p className={TRUST_BADGES_STYLES.title}>{title}</p>}

        <ul className={TRUST_BADGES_STYLES.list}>
          {badges.map((badge) => {
            const logo = (
              <img
                src={badge.logoUrl}
                alt={badge.alt}
                className={TRUST_BADGES_STYLES.logo}
                loading="lazy"
            decoding="async"
              />
            );

            return (
              <li key={badge.id} className={TRUST_BADGES_STYLES.item}>
                {badge.href ? (
                  <a
                    href={badge.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={badge.alt}
                  >
                    {logo}
                  </a>
                ) : (
                  logo
                )}
              </li>
            );
          })}
        </ul>
      </section>
    );
  }
);

TrustBadges.displayName = "TrustBadges";
